import { Group } from 'lib/_types'
import { endpoints } from 'store/api/yay/group'

export const useGroupCategory = (group: Group) => {
  const groupCategoriesRes = endpoints?.getGroupCategories?.useQueryState?.({})

  const groupCategory = groupCategoriesRes?.data?.find?.(
    (x) => x?.id == group?.group_category_id
  )

  return groupCategory
}
